// import { v4 as uuidv4 } from "uuid";

// export const drawerWidth = 300;
// //App Paths
// export const APP_LOGIN = `/login-${uuidv4()}`;
// export const APP_AUTH = "/auth";
// export const APP_SET_PIN = `/set-pin-${uuidv4()}`;
// export const APP_PIN_ENTER = `/enter-pin-${uuidv4()}`;
// export const APP_FORGOT_PASSWORD = `/forgot-password-${uuidv4()}`;
// export const APP_FORGOT_PASSWORD_OTP_VERIFY = `/verify-otp-${uuidv4()}`;
// export const APP_CHANGE_PASSWORD = `/change-password-${uuidv4()}`;
// export const APP_CHANGE_CURRENT_PASSWORD = `/change-currentpassword-${uuidv4()}`;
// export const APP_DEFAULT_URL = "/";
// export const APP_DASHBOARD_URL = "/dashboard";
// export const APP_EMPLOYEE_LIST_URL = "/employee";
// export const APP_CONTROL_CONFIG_URL = "/config/controls";
// export const APP_UI_CONFIG_URL = "/config/ui";
// export const APP_REPORT_URL = `/employee/reports/:id`;
// export const APP_TIMESHEET_URL = "/timesheet";
// export const APP_PAYSLIP_URL = "/payslip";
// export const APP_UPLOAD_DOCUMENTS_URL = "/upload-documents";
// export const APP_WPS_URL = "/wps";
// export const APP_UPLD_FINCL_ENTRY_URL = "/finance";
// export const APP_UPLD_PO_URL = "/purchase";
// export const APP_UPLOAD_TEMPLATE_URL = `/file-upload/files/:id`;

// export const TOKEN_KEY = "erps_token";
// export const CURRENT_USER_CODE = "erps_user";
// export const DEFAULT_DATE_FORMAT = "dd-MMM-yy";

export const drawerWidth = 300;

// App Paths
export const APP_LOGIN = '/login-a3f8b2c1';
export const APP_AUTH = '/auth';
export const APP_SET_PIN = '/set-pin-d4e9f1a2';
export const APP_PIN_ENTER = '/enter-pin-b5c7d3e8';
export const APP_FORGOT_PASSWORD = '/forgot-password-f2a1b9c4';
export const APP_FORGOT_PASSWORD_OTP_VERIFY = '/verify-otp-e6d4c2b1';
export const APP_CHANGE_PASSWORD = '/change-password-a8f3e5d2';
export const APP_CHANGE_CURRENT_PASSWORD = '/change-currentpassword-c9b7a4f1';
export const APP_DEFAULT_URL = '/';
export const APP_DASHBOARD_URL = '/dashboard';
export const APP_EMPLOYEE_LIST_URL = '/employee';
export const APP_CONTROL_CONFIG_URL = '/config/controls';
export const APP_UI_CONFIG_URL = '/config/ui';
export const APP_REPORT_URL = '/employee/reports/:id';
export const APP_TIMESHEET_URL = '/timesheet';
export const APP_PAYSLIP_URL = '/payslip';
export const APP_UPLOAD_DOCUMENTS_URL = '/upload-documents';
export const APP_WPS_URL = '/wps';
export const APP_UPLD_FINCL_ENTRY_URL = '/finance';
export const APP_UPLD_PO_URL = '/purchase';
export const APP_UPLOAD_TEMPLATE_URL = '/file-upload/files/:id';
export const APP_ACTIVITY_LOGS_URL = '/activity-logs';

export const TOKEN_KEY = 'erps_token';
export const CURRENT_USER_CODE = 'erps_user';
export const DEFAULT_DATE_FORMAT = 'dd-MMM-yy';
